/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const fr_agencies_too_expensive_and_freelancers_miss_context = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les agences classiques sont hors de prix et les freelances ne comprennent pas votre métier.`)
};

const en_agencies_too_expensive_and_freelancers_miss_context = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traditional agencies are too expensive and freelancers don't understand your business.`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const agencies_too_expensive_and_freelancers_miss_context = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.agencies_too_expensive_and_freelancers_miss_context(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("agencies_too_expensive_and_freelancers_miss_context", locale)
	if (locale === "fr") return fr_agencies_too_expensive_and_freelancers_miss_context(inputs)
	return en_agencies_too_expensive_and_freelancers_miss_context(inputs)
};